import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store"
import axios from "../axios"

//引用页面
import login from '../views/login.vue'
import home from '../views/iems-home.vue'
import myConst from "../util/my-const";
import fa from "element-ui/src/locale/lang/fa";
import myApi from "../util/my-api";
import fun  from '@/util/util'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'login',
        component: login
    },
    {
        path: '/carbon',
        name: 'carbon',
        component: ()=>import('@/views/escrms-home.vue')
    },
    {
        path: '/rf',
        name: 'rf',
        component: () => import('@/views/large-screen-home.vue'),
        redirect: '/large2',  //默认加载路由
        children: [
            {
                path: "/large1",
                name: "large1",
                component: () => import('@/views/large_screen/renfang/large-screen-1.vue'),
            },
            {
                path: "/large3d",
                name: "large3d",
                component: () => import('@/views/large_screen/renfang/large-screen-3d.vue'),
            },
            {
                path: "/large2",
                name: "large2",
                component: () => import('@/views/large_screen/renfang/large-screen-2.vue'),
            }
        ]
    },
    {
        path: "/shanxi",
        name: "shanxi",
        component: ()=>import("../components/topology/shan-xi.vue")
    },
    {
        path: "/jilin",
        name: "jilin",
        component: ()=>import("../components/topology/jilin/ji-lin.vue")
    },
    {
        path: "/zjk",
        name: "zjk",
        component: ()=>import("../components/topology/zjk.vue")
    },
    {
        path: "/zjk1",
        name: "zjk1",
        component: ()=>import("../components/topology/zjk1.vue")
    },
    {
        path: "/yangzhou",
        name: "yangzhou",
        component: ()=>import("../components/topology/yangzhou.vue")
    },
    {
        path: "/wuhan",
        name: "wuhan",
        component: ()=>import("../components/topology/wuhan.vue")
    },
    {
        path: "/jilinGuangyu",
        name: "jilinGuangyu",
        component: ()=>import("../components/topology/jilin/jilin-guangyu.vue")
    },
    {
        path: "/jilinQingChu",
        name: "jilinQingChu",
        component: ()=>import("../components/topology/jilin/jilin-qingchu.vue")
    },
    {
        path: "/yanda",
        name: "yanda",
        component: ()=>import("../components/topology/yanda.vue")
    },
    {
        path: "/yushan",
        name: "yushan",
        component: ()=>import("../components/topology/yushan.vue")
    },
    {
        path: "/jilin1",
        name: "jilin1",
        component: ()=>import("../components/topology/jilin/ji-lin1.vue")
    },
    {
        path: "/sanya",
        name: "sanya",
        component: ()=>import("../components/topology/sanya.vue")
    },
    {
        path: "/qinghai",
        name: "qinghai",
        component: ()=>import("../components/topology/qinghai.vue")
    },
    {
        path: "/xinjiang",
        name: "xinjiang",
        component: ()=>import("../components/topology/xinjiang/xin-jiang.vue")
    },
    {
        path: "/xinjiang1",
        name: "xinjiang1",
        component: ()=>import("../components/topology/xinjiang/xin-jiang1.vue")
    },
    {
        path: "/xinjiang2",
        name: "xinjiang2",
        component: ()=>import("../components/topology/xinjiang/xin-jiang-new.vue")
    },
    {
        path: "/xinjiang3",
        name: "xinjiang3",
        component: ()=>import("../components/topology/xinjiang/xinjiangweiwang.vue")
    },
    {
        path: "/xinjiang4",
        name: "xinjiang4",
        component: ()=>import("../components/topology/xinjiang/xinjiang-bazhou.vue")
    },
    {
        path: "/xinjiang5",
        name: "xinjiang5",
        component: ()=>import("../components/topology/xinjiang/xin-jiang2.vue")
    },
    {
        path: "/jianyanyuan",
        name: "jianyanyuan",
        component: ()=>import("../components/topology/jianyanyuan.vue")
    },
    {
        path: "/jianyanyuan1",
        name: "jianyanyuan1",
        component: ()=>import("../components/topology/jianyanyuan1.vue")
    },
    {
        path: "/tianjin",
        name: "tianjin",
        component: ()=>import("../components/topology/tianjin.vue")
    },
    {
        path: "/tupian",
        name: "tupian",
        component: ()=>import("../components/topology/tupian.vue")
    },
    {
        path: "/jilin2",
        name: "jilin2",
        component: ()=>import("../components/topology/jilin/ji-lin2.vue")
    },
    {
        path: "/jilin3",
        name: "jilin3",
        component: ()=>import("../components/topology/jilin/ji-lin3.vue")
    },
    // {
    //     path: "/canvas",
    //     name: "canvas",
    //     component: ()=>import("../components/topology/xinjiang/canvasDemo.vue")
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

//路由拦截
let oneRun = true;//通过oneRun变量控制 避免添加路由陷入死循环
router.beforeEach(async (to, from, next) => {
    //检索大屏页面关键字
    let index = -1;
    if (to.name == "login" || index >= 0) {
        next();
    } else if (!store.getters.getTokenIsEnable) {
        console.log("token无效!");
        // next({path: "/"});
        localStorage.clear()
        sessionStorage.clear()
    } else if (to.name !== 'login' && !fun.isNull(to.path)) {
        let sysType = getRouteSysType(store.getters.getRouterList,to.path,'')
        if(sysType == myConst.sysType.integratedSys){ //如果当前获取的是综合系统的菜单
            if(!store.getters['integSysMenu/getIntegrSysMenu']){
                await loadMenu(sysType).then(result=>{
                    // console.log("进入综合系统");
                    store.commit('integSysMenu/setIntegrSysMenu',result)
                })
            }
        } else if(sysType == myConst.sysType.energyStorageSys){  //如果当前获取的是胡能系统的菜单
            if(!store.getters['enerStorSysMenu/getEnergyStorageSysMenu']){
                // console.log("进入储能系统");
                await loadMenu(sysType).then(result=>{
                    // console.log(result);
                    store.commit('enerStorSysMenu/setEnergyStorageSysMenu',result)
                })
            }
        } else if(sysType == myConst.sysType.photovoltaicSys){  //如果当前获取的是光伏系统的菜单
            console.log("进入光伏系统");
            if(!store.getters(['photovoltaicSysMenu/getPhotovoltaicSysMenu'])){
                loadMenu(sysType).then(result=>{
                    store.commit('photovoltaicSysMenu/setPhotovoltaicSysMenu',result)
                })
            }
        } else if(fun.isNull(sysType) && (to.path == "/rf" || to.path == '/large1' || to.path == "/large3d" || to.path == "/large2" || to.path == '/carbon')){
            // console.log("人防");
        }else {
            // next({path: "/"});
        }

        // next()
    }
    if (store.getters.getRouterList) {
        if (oneRun) {
            addRouter(store.getters.getRouterList)
            let newRoutes = router.options.routes;
            store.getters.getRouterList.forEach(item=>{
                newRoutes.push(item)
                router.addRoute(item)
            })
            oneRun = false
            next({...to, replace: true})// 必不可少的，确保你的动态路由创建成功再去执行其它代码
        }
    }
    // store.commit('CanCelRequest/clearToken')
    next();
})

const addRouter = (list) => {  //菜单转路由
    if(Array.isArray(list)){
        list.forEach(item=>{
            item.path = fun.isNull(item.homePath)?'router':item.homePath,
                item.name = item.homeName,
                item.component = ()=>import('@/views/' + item.filePath)
            addRouter(item.children)
        })
    }

}

const loadMenu = sysType =>{
    return new Promise((resolve,reject)=>{
        axios.get(myApi.getMenuByPermission + "?sysType=" + sysType).then(res=>{
            if(res.data.code === myConst.code.success){
                let arr = res.data.data
                if(arr.length > 0){
                    arr.forEach(x=>{
                        if(Array.isArray(x.children) && x.children.length > 0){
                            x.children.map(item=>{
                                item.isSel = false
                            })
                        }
                    })
                }
                resolve(arr)
            } else {
                reject()
            }
        })
    })

}

const getRouteSysType = (arr, path,sysType) =>{
    arr.forEach(item=>{
        if(item.homePath == path){
            sysType = item.sysType
        }
        if(!fun.isNull(item.children) && item.children.length > 0){
            sysType = getRouteSysType(item.children, path,sysType)
        }
    })
    return sysType
}


//解决报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalPush.call(this, location, onResolve, onReject)
    }
    return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function push(location, onResolve, onReject) {
    if (onResolve || onReject) {
        return originalReplace.call(this, location, onResolve, onReject)
    }
    return originalReplace.call(this, location).catch(err => err)
}

export default router
